// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"MetalsLinks_linkWrapper__oJalX","adminWrapper":"MetalsLinks_adminWrapper__3c3Ak"};